import Select from "react-select";

const AgreementSelect = ({
  userSetting,
  customerAgreements,
  selectedAgreementId,
  setSelectedAgreementId,
}) => {
  if (!userSetting?.HasExtraProducts) {
    return null;
  }

  const agreementIds = (userSetting?.Agreements || "")
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);

  const options = agreementIds.map((agreementId) => {
    const match = customerAgreements.find(
      (x) => String(x.AgreementId) === String(agreementId),
    );

    return {
      value: agreementId,
      label: `${agreementId} - ${match?.AgreementName || "Namn saknas"}`,
    };
  });

  const selectedOption =
    options.find((x) => String(x.value) === String(selectedAgreementId)) ||
    null;

const styles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#fd7e14",
    border: "none",
    borderRadius: "999px",
    boxShadow: "none",
    minHeight: "30px",
    height: "34px",
    paddingLeft: "8px",
    paddingRight: "8px",
    width: "235px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 4px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#ffffff",
    fontSize: "15px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#ffffff",
    fontSize: "15px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#ffffff",
    padding: "4px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: "rgba(255,255,255,0.5)",
    marginTop: 5,
    marginBottom: 5,
  }),
};

  return (
    <Select
      classNamePrefix="react-select"
      isSearchable={false}
      placeholder="Välj avtal..."
      value={selectedOption}
      options={options}
      onChange={(option) => setSelectedAgreementId(option?.value || "")}
      styles={styles}
    />
  );
};

export default AgreementSelect;
